import React, { useState, useEffect ,useRef} from "react";
import { API_IP, API_PORT } from "./AppConfig/AppConfig";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import yerlemlogo from "../images/yerlemlogo.svg";
import yerlembg from "../images/yerlemicon.svg";
import { Toast } from "primereact/toast";

export default function MainPage({ setSidebarVisible }) {

  const toast = useRef(null);

  const [buttonsData, setButtonsData] = useState([]);
  const [selectedAppdata, setSelectedAppdata] = useState([]);
  const [selectedInstanceData, setSelectedInstanceData] = useState([]);
  const [selectedAppId, setSelectedAppId] = useState(null);
  const [selectedAppInstanceId, setSelectedAppInstanceId] = useState(null);
  const [selectedRealmId, setSelectedRealmId] = useState(null);
  const [appToken, setAppToken] = useState(null);
  const [hideApp, setHideApp] = useState(false);
  const [hideInstance, setHideInstance] = useState(false);
  const [hideDataButton, setHideDataButton] = useState(false);

  const navigate = useNavigate();

  const showWarningInstance = () => {
    toast.current.show({
      severity: "warn",
      summary: "Hata",
      detail: "Bu app isteğine göre geçerli instance bulunamadı",
      life: 3000,
    });
  };
  const showWarningApp = () => {
    toast.current.show({
      severity: "warn",
      summary: "Hata",
      detail: "Bu realm isteğine göre geçerli app bulunamadı",
      life: 3000,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tokenResponse = await fetch(
          `http://${API_IP}:${API_PORT}/api/auth`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: "kimlik",
              password: "ff147b70-6b7a-482a-82f4-23ecc5186c54",
            }),
          }
        );

        if (!tokenResponse.ok) {
          throw new Error("Token alınırken bir hata oluştu");
        }

        const tokenData = await tokenResponse.json();
        const token = tokenData.data.token;
        setAppToken(tokenData.data.token);

        const response = await fetch(`http://${API_IP}:${API_PORT}/api/realm`, {
          headers: {
            Authorization: `kimlik ${token}`,
          },
        });
        const data = await response.json();
        setButtonsData(data.data);
      } catch (error) {
        console.error("API'den veri alınırken bir hata oluştu:", error);
      }
    };

    fetchData();
  }, []);

  const handleListUserOnClick = () => {
    // Seçilen kullanıcıları listeleme sayfasına yönlendirme yapılırken state gönderilir.
    navigate("/selectedUsers", { state: { selectedAppInstanceId } });
  };
  const handleRealmChange = async (realmId) => {
    try {
      setSelectedInstanceData(null);
      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/realm-app-relation/findAllByRealmId?realmId=${realmId.id}`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`,
          },
        }
      );
      const data = await response.json();
      const appId = data?.data.map((item) => item.app);
      if(data.data.length === 0) {
showWarningApp();
      }
      else if (appId) {
        setSelectedAppId(appId);
        setSelectedAppdata(appId);
        setSelectedAppInstanceId(null); // Instance butonlarını sıfırlıyoruz
        setHideApp(true);
      } else {
        console.error("App ID bulunamadı.");
        setSelectedAppInstanceId(null); // Instance butonlarını sıfırlıyoruz
        setSelectedAppId(null); // Instance butonlarını sıfırlıyoruz
      }
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
    }
    setSelectedRealmId(realmId);
  };

  const handleAppChange = async (newAppId) => {
    try {
      const response = await fetch(
        `http://${API_IP}:${API_PORT}/api/app-instance/findAllByAppId?appId=${newAppId.id}`,
        {
          headers: {
            Authorization: `kimlik ${appToken}`,
          },
        }
      );
      const data = await response.json();
      const appInstanceIds = data?.data.map((item) => item.id);
      if (data.data.length === 0) {
        showWarningInstance()
      } else if (appInstanceIds.length > 0) {
        setSelectedAppInstanceId(newAppId);
        setSelectedInstanceData(appInstanceIds);
        setHideInstance(true);
      } else {
        console.error("Instance ID bulunamadı.");
      }
    } catch (error) {
      console.error("API'den veri alınırken bir hata oluştu:", error);
    }
    setSelectedAppId(newAppId);
  };

  const handleInstanceAppChange = async (value) => {
    try {
      setSelectedAppInstanceId(value);
      setHideDataButton(true);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="h-screen bg-cyan-50 rounded-3xl  flex flex-col justify-center items-center">
      <img src={yerlembg} className="absolute h-full object-cover z-0 " />
      <img src={yerlemlogo} className="w-[30%]" />
      <div className="p-4 card w-full text-center">
      <Toast ref={toast} />

        <div className="absolute top-2 left-2">
          <Button
            severity="info"
            label="Menu"
            icon="pi pi-bars"
            onClick={() => setSidebarVisible((visible) => !visible)}
          />
        </div>
        <div className="flex flex-wrap justify-around mt-4 ">
          <Dropdown
            value={selectedRealmId}
            onChange={(e) => handleRealmChange(e.value)}
            options={buttonsData}
            optionLabel="id"
            placeholder="Realm Seçiniz"
            className="w-full font-bold	"
          />
        </div>

        {hideApp ? (
          <div className="flex flex-wrap gap-2 mt-4 justify-around">
            <Dropdown
              value={selectedAppId}
              onChange={(e) => handleAppChange(e.value)}
              options={selectedAppdata}
              optionLabel="id"
              placeholder="App Seçiniz"
              className="w-full font-bold	"
            />
          </div>
        ) : null}

        {hideInstance ? (
          <div className="flex flex-wrap gap-2 mt-4 justify-around">
            <Dropdown
              value={selectedAppInstanceId}
              onChange={(e) => handleInstanceAppChange(e.value)}
              options={selectedInstanceData}
              placeholder="Instance Seçiniz"
              className="w-full font-bold	"
            />
          </div>
        ) : null}

        {hideDataButton ? (
          <div className="flex flex-wrap gap-2 mt-4 justify-around">
            <Button
              className="w-full"
              icon="pi pi-chevron-right"
              iconPos="right"
              severity="info"
              label="Kullanıcıları Listele"
              onClick={handleListUserOnClick}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
